import { Box, TextField } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../../components/Header";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import TextFieldCompnent from "../../../components/textFieldComponent";
import { useRestaurant } from "../../../hooks/RestaurantContext";
import ButtonComponent from "../../../components/ButtonComponent";
import { getSettingsError, getSettingsLoading, getSettingsStatus, getSettingsSuccess, updateSetting, updateStatus } from "../../../features/settingSlice";
import BackButton from "../../../components/backButton";
import { useTranslation } from "react-i18next";

const ModifyMail = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const data = location.state.mail;
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const { restaurantId } = useRestaurant();
    const status = useSelector(getSettingsStatus);
    const error = useSelector(getSettingsError);
    const loading = useSelector(getSettingsLoading);
    const success = useSelector(getSettingsSuccess);
    

    const schema = yup.object().shape({
        host: yup.string().required("Hôte est requis"),
        port: yup.number().required("Port est requis"),
        emailUser: yup.string()
            .email("E-mail invalide")
            .required("E-mail de configuration est obligatoire"),
        emailSender: yup.string()
            .email("E-mail invalide")
            .required("E-mail d'affichage est obligatoire"),
        emailName: yup.string().required("Nom d'affichage est requis"),
    });

    const initialValues = {
        host: data.host || "",
        port: data.port || "",
        emailUser: data.emailUser || "",
        emailSender: data.emailSender || "",
        emailName: data.emailName || "",
        isPasswordSet: data.isPasswordSet || false,
    };

    const handleFormSubmit = (values) => {
        const formData = new FormData();
        formData.append("host", values.host);
        formData.append("port", values.port);
        formData.append("emailUser", values.emailUser);
        formData.append("emailSender", values.emailSender);
        formData.append("emailName", values.emailName);
        if (values.emailPass)
            formData.append("emailPass", values.emailPass);
        dispatch(updateSetting({ formData, restaurantId }));
    };
    
    useEffect(() => {
        if (status === "updateSettingSuccess") {
            toast.success(success);
            dispatch(updateStatus());
            navigate("/mailing");
        } else if (status === "updateSettingError") {
            toast.error(error);
        }
    }, [status, error, dispatch, navigate, success]);

    return (
        <Box m="20px" className="main-application">
            <BackButton/>
            <Header title={t("headers.editEmail")} subtitle={t("headers.editEmailSub")} />
            <Formik
                onSubmit={handleFormSubmit}
                initialValues={initialValues}
                validationSchema={schema}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                }) => (
                    <form onSubmit={handleSubmit}>
                        <Box
                            display="grid"
                            gap="16px"
                            gridTemplateColumns="repeat(6, minmax(0, 1fr))"
                            sx={{
                                "& > div": { gridColumn: isNonMobile ? undefined : "span 6" },
                            }}
                        >
                            <TextFieldCompnent
                                type="text"
                                label={t("fields.host")}
                                change={handleChange}
                                value={values.host}
                                name="host"
                                blur={handleBlur}
                                touched={touched.host}
                                error={errors.host}
                                colum="span 3"
                                row="1 / span 1"
                                required
                            />
                            <TextFieldCompnent
                                type="number"
                                label={t("fields.port")}
                                change={handleChange}
                                value={values.port}
                                name="port"
                                blur={handleBlur}
                                touched={touched.port}
                                error={errors.port}
                                colum="span 3"
                                row="2 / span 1"
                                num={0}
                                required
                            />
                            <TextFieldCompnent
                                type="email"
                                label={t("fields.emailConfig")}
                                change={handleChange}
                                value={values.emailUser}
                                name="emailUser"
                                blur={handleBlur}
                                touched={touched.emailUser}
                                error={errors.emailUser}
                                colum="span 3"
                                row="3 / span 1"
                                required
                            />
                            <TextFieldCompnent
                                type="email"
                                label={t("fields.emailDisplay")}
                                change={handleChange}
                                value={values.emailSender}
                                name="emailSender"
                                blur={handleBlur}
                                touched={touched.emailSender}
                                error={errors.emailSender}
                                colum="span 3"
                                row="4 / span 1"
                                required
                            />
                            <TextFieldCompnent
                                type="text"
                                label={t("fields.displayName")}
                                change={handleChange}
                                value={values.emailName}
                                name="emailName"
                                blur={handleBlur}
                                touched={touched.emailName}
                                error={errors.emailName}
                                colum="span 3"
                                row="5 / span 1"
                                required
                            />
                            <TextField
                                variant="filled"
                                type="password"
                                label={t("fields.password")}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                defaultValue={values.isPasswordSet ? "*****" : ""}
                                value={values.emailPass}
                                name="emailPass"
                                error={touched.emailPass && Boolean(errors.emailPass)}
                                helperText={touched.emailPass && errors.emailPass}
                                sx={{ gridColumn: "span 3", gridRow: "6 / span 1" }}
                            />
                        </Box>
                        <ButtonComponent text={t("common.edit")} loading={loading} />
                    </form>
                )}
            </Formik>
        </Box>
    );
};

export default ModifyMail;
